import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import { FirebaseAuthContext } from 'libs.firebase_react';
import { ApiClientService, useApiClient } from 'libs.react_internal';
export function useStudyTranslationTransition(id) {
    const { post } = useApiClient(ApiClientService.CLOUD);
    const { firebaseToken } = useContext(FirebaseAuthContext);
    return useMutation({
        mutationKey: ['study', 'translations', 'transition', id],
        mutationFn: (body) => {
            return post('/translation/study_translation_transition', body, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${firebaseToken}`,
                },
                withCredentials: false,
            });
        },
        retry: false,
    });
}
